export enum PurchaseCreditsType {
  EV_CREDITS = 'EV_CREDITS',
  AI_CREDITS = 'AI_CREDITS',
  LF_CREDITS = 'LF_CREDITS',
}

export enum CreditsTransactionStatus {
  PAID = 'paid',
  FAILED = 'failed',
  PENDING = 'pending',
}

export interface CalculateCreditsPricesRequest {
  creditCounts: number[];
  type: PurchaseCreditsType;
  currencyCode: string;
}

export interface CalculateCreditsPricesResponse {
  [key: string]: any;
}

export interface PurchaseCreditsRequest {
  creditCount: number;
  type: PurchaseCreditsType;
  currencyCode: string;
  paymentProvider?:string
}

export interface PurchaseCreditsResponse {
  transaction: {
    success: boolean;
    transactionId: string;
    orderId: string;
  };
}

export interface CreditsPlan {
  id: string;
  amount: number;
  name: string;
  isBestValue: number;
  credits: number;
}
export enum CreditsTransactionType {
  EV_CREDITS = 'ev-credits',
  AI_CREDITS = 'ai-credits',
  LF_CREDITS = 'lf-credits',
}
export interface CreditsTransactionStatusRequest {
  type: CreditsTransactionType;
  orderId: number;
}

export interface CreditsTransactionStatusResponse {
  status: CreditsTransactionStatus;
  shouldPoll: boolean;
}
